export const transformTabListEnums = (data) => {
  const transformedData = { ...data };
  transformedData?.tabs?.forEach?.((tab) => {
    if (tab?.enum === "telegramGroup") tab.enum = "group";
    if (tab?.enum === "lockedMessage") tab.enum = "message";
  });
  // transformedData.bankDetails = {};
  return transformedData;
};
